export const onClear = () => ({
  type: 'CLEAR'
})

export const onSetAsset = (asset) => ({
  type: 'SET_ASSET',
  asset
})